import * as R from "ramda";

export const stats = state => state.passes.stats;
export const searchResults = state => state.passes.list;
export const currentPage = state => state.passes.pagination.page || 0;
export const pageSize = state => state.passes.pagination.pageSize || 10;
export const pages = state => state.passes.pagination.pages || 0;

export const getOpenedMenues = R.pathOr({}, ["passes", "menues", "opened"]);
